import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import StudioCasesPage from '../../features/studio-cases/components/StudioCasesPage';

const StudioCasesRoute = () => {
  return (
    <ProtectedRoute requiresAuth>
      <StudioCasesPage />
    </ProtectedRoute>
  );
};

export default StudioCasesRoute;
